import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Flowmeter } from 'src/app/storage/models/flowmeter.model';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class FlowmetersService {

  flowmeters$: BehaviorSubject<Flowmeter[]> = new BehaviorSubject(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getFlowmeters(marketname: string, missionId: string): Promise<Flowmeter[] | null> {
    const translations = await this.translateService.get('FLOWMETERS').toPromise();

    const response = await this.apiService.get(
      `${URL}flowmeters/market/${marketname}/${missionId}`,
      translations['LABEL']
    );

    return response ?
          response.flowmeters.map(flowmeter => new Flowmeter(flowmeter)) :
          null;
  }
}
